var styles = {"root":"Checkbox-module_root__1aDHw","input":"Checkbox-module_input__9Xzi_","fakeCheckbox":"Checkbox-module_fakeCheckbox__3lNCT","error":"Checkbox-module_error__1BWsH"};

export { styles as default };
//# sourceMappingURL=Checkbox.module.css.js.map
